import { UpdateUserRolesEndAction } from "../actions/UpdateUserRoles";
import { OrgState } from "../state";

export function updateUserRoles(state: OrgState, action: UpdateUserRolesEndAction) {
    const { error, organizationId } = action.payload;

    if (error) {
        return { ...state, ...error };
    } else {
        const updatedUser = action.payload.user;
        const orgUsers = state.users[organizationId];
        const updatedIndex = orgUsers.findIndex(user => {
            return user.userId === updatedUser.userId;
        });
        const updatedUsers = orgUsers.slice(0, updatedIndex).concat(updatedUser, orgUsers.slice(updatedIndex + 1));

        return {
            ...state,
            users: {
                ...state.users,
                [organizationId]: updatedUsers
            }
        };
    }
}
